import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1a7635bc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1a7635bc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7635bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a7635bc')) {
      api.createRecord('1a7635bc', component.options)
    } else {
      api.reload('1a7635bc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1a7635bc&scoped=true", function () {
      api.rerender('1a7635bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/distribution/alliance/promoter-center/index.vue"
export default component.exports